export default "__VITE_ASSET__Bx09xFkr__"